"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _moment = _interopRequireDefault(require("moment"));

var _challengeRankingGroupingFilters = require("./challengeRankingGroupingFilters");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getGroupingConfig = function getGroupingConfig(_ref) {
  var groupingName = _ref.groupingName,
      userParentGroupId = _ref.userParentGroupId,
      subGroupId = _ref.subGroupId;
  var topParentFilter = {
    topParent: userParentGroupId
  };
  var subGroupIdFilter = {
    group: subGroupId
  };
  var userFilter = subGroupId ? subGroupIdFilter : topParentFilter;
  var groupingConfig = {
    groupsTopParent: {
      rankingType: 'groups',
      subgroup: false
    },
    groupsChildren: {
      rankingType: 'groups',
      parent: userParentGroupId,
      subgroup: true
    },
    allGroupsChildren: {
      rankingType: 'groups',
      subgroup: true
    },
    users: _objectSpread({
      rankingType: 'users'
    }, userFilter),
    allUsers: {
      rankingType: 'users'
    }
  };
  return groupingConfig[groupingName];
};

var getPeriodConfig = function getPeriodConfig() {
  var now = (0, _moment["default"])();
  var currentMonth = now.month();
  var currentYear = now.year();
  var currentWeek = now.isoWeek();
  var weeksInYear = now.weeksInYear();
  return {
    week: {
      week: currentWeek,
      year: currentYear,
      progress: 'week'
    },
    month: {
      month: currentMonth,
      year: currentYear,
      progress: 'month'
    },
    year: {
      year: currentYear,
      progress: 'year'
    },
    lastWeek: {
      week: currentWeek === 1 ? weeksInYear : currentWeek - 1,
      year: currentWeek === 1 ? currentYear - 1 : currentYear,
      progress: 'week'
    },
    lastMonth: {
      month: currentMonth === 0 ? 11 : currentMonth - 1,
      year: currentMonth === 0 ? currentYear - 1 : currentYear,
      progress: 'month'
    },
    lastYear: {
      year: currentYear - 1,
      progress: 'year'
    },
    allTime: {
      allTime: true
    },
    none: {}
  };
};

var parseFilters = function parseFilters(_ref2) {
  var _filters$sport;

  var filters = _ref2.filters,
      sportFilters = _ref2.sportFilters,
      userParentGroupId = _ref2.userParentGroupId,
      subGroupId = _ref2.subGroupId,
      _ref2$groupRestrictio = _ref2.groupRestriction,
      groupRestriction = _ref2$groupRestrictio === void 0 ? false : _ref2$groupRestrictio,
      challengeId = _ref2.challengeId,
      _ref2$withProgress = _ref2.withProgress,
      withProgress = _ref2$withProgress === void 0 ? true : _ref2$withProgress;

  if (challengeId) {
    filters.period = 'none';
    filters.sport = 'all';
  }

  var periodConfig = getPeriodConfig();
  var grouping = challengeId ? (0, _challengeRankingGroupingFilters.getChallengeRankingGroupingConfig)({
    groupingName: filters.grouping,
    userParentGroupId: userParentGroupId,
    subGroupId: subGroupId,
    challengeId: challengeId
  }) : getGroupingConfig({
    groupingName: filters.grouping,
    userParentGroupId: userParentGroupId,
    subGroupId: subGroupId,
    groupRestriction: groupRestriction
  });
  var period = periodConfig[filters.period];
  var calculationMethod = filters.calculationMethod === 'total' ? '' : filters.calculationMethod;
  var keySport = null;

  if (!sportFilters) {
    keySport = 'sport';
  } else {
    keySport = sportFilters[filters.sport] ? 'sport' : 'sportCategory';
  }

  var parsedFilters = _objectSpread((0, _defineProperty2["default"])({}, keySport, (filters === null || filters === void 0 ? void 0 : (_filters$sport = filters.sport) === null || _filters$sport === void 0 ? void 0 : _filters$sport.toLowerCase()) !== 'all' ? filters.sport : undefined), grouping, {}, period, {
    progress: withProgress ? period === null || period === void 0 ? void 0 : period.progress : undefined,
    sort: "-".concat(filters.sort).concat(calculationMethod)
  });

  return parsedFilters;
};

var _default = parseFilters;
exports["default"] = _default;
//# sourceMappingURL=parseFilters.js.map